import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import styles from './spinner.scss'

interface IProps {
  className?: string
  size?: number
}

const Spinner = ({ className, size = 3 }: IProps = {}) => (
  <div className={cn(styles.container, className)}>
    <div className={styles.one} style={{ height: size, width: size }}></div>
    <div className={styles.two} style={{ height: size, width: size }}></div>
    <div className={styles.three} style={{ height: size, width: size }}></div>
  </div>
)

export default observer(Spinner)
